import { CrudService as CrudServiceBase } from './crud.service.base';
import { Injectable } from '@angular/core';

@Injectable()
export abstract class CrudService<TApiModel, TId> extends CrudServiceBase<TApiModel, TApiModel, TId> {}
